import { gql } from '@apollo/client';

import { useQuery } from '@fhs/client';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import { GetGiftCardBalanceInput, GetGiftCardBalancePayload } from '../utils/types';

const GetGiftCardBalanceQuery = gql`
  query GetGiftCardBalance($input: GetGiftCardBalanceInput) @gateway @authRequired {
    getGiftCardBalance(input: $input) {
      giftCard {
        currentBalance
      }
    }
  }
`;

export const useGetBalanceQuery = ({
  token,
  pin,
  expiryDate,
  isPhysicalCardBalanceCheck,
  fetchBalance = true,
}: GetGiftCardBalanceInput & { fetchBalance?: boolean }) => {
  return useQuery({
    enabled: fetchBalance,
    queryKey: ['getBalance', token, pin, expiryDate, isPhysicalCardBalanceCheck],
    staleTime: 0,
    gcTime: 0,
    retry: false,
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardBalanceQuery,
        fetchPolicy: 'no-cache',
        variables: {
          input: {
            token,
            pin,
            expiryDate,
            isPhysicalCardBalanceCheck,
          },
        },
      });
      return data?.getGiftCardBalance?.giftCard as GetGiftCardBalancePayload;
    },
  });
};
